import { UserSettings } from "../../../Syntess.Web.Shared/Utils/UserSettings";

export class PortalUserSettings extends UserSettings { }
